import { render, staticRenderFns } from "./CoursesDetails.vue?vue&type=template&id=69b967cb&scoped=true"
import script from "./CoursesDetails.vue?vue&type=script&lang=js"
export * from "./CoursesDetails.vue?vue&type=script&lang=js"
import style0 from "./CoursesDetails.vue?vue&type=style&index=0&id=69b967cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b967cb",
  null
  
)

export default component.exports